import api from '../../api';

const path = '/sell/all/bike';

export const getBikeAllRequest = (id) => api.get(`${path}/get/${id}`);
export const getBikeAllListRequest = (params) =>
    api.get(`${path}/get`, { params });

export const getBikeNoAccountRequest = (id) =>
    api.get(`${path}/list/get/${id}`);
export const getBikeNoAccountListRequest = (params) =>
    api.get(`${path}/list/get`, { params });
